// extracted by mini-css-extract-plugin
module.exports = {"center":"_057a3ae"};